<template>
  <div >
      <div id="serviceMap"></div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: {
  },
  data() {
    return {
      map:null
    };
  },
   created() {
    this.initMap();
  },
  methods:{
      initMap(){
          AMapLoader.load({
        key: "eaefb72a3b97bcdb4b649a13235914bb", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        AMapUI: {
          version: "1.1",
          plugins: ["overlay/SimpleMarker", "overlay/SimpleInfoWindow"],
        },
        plugins: ["AMap.Marker", "AMap.ToolBar", "AMap.Driving","AMap.Geolocation"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          console.log('43434',AMap);
          this.map = new AMap.Map("serviceMap", {
            //设置地图容器id
            mapStyle: "amap://styles/blue", //设置地图的显示样式
            viewMode: "2D", //是否为3D地图模式
            zoom: 20, //初始化地图级别
            center: [113.7550342, 23.0361437], //初始化地图中心点位置
          });


        })
        .catch((e) => {
          console.log("创建地图失败", e);
        });
      }
  },
  computed: { },
};
</script>
<style scoped>
#serviceMap{
    width: 1920px;
  height: 1080px;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceMap.vue